/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ClassroomDisciplineBotExamGridItemRepositoryResponse } from "../types/ClassroomDisciplineBotExamGridItemRepositoryResponse.ts";

export const classroomDisciplineBotExamGridItemRepositoryResponseSchema =
  z.object({
    id: z.optional(
      z
        .number()
        .int()
        .describe("ID da prova bot gerada para a disciplina da turma."),
    ),
    disciplineName: z
      .string()
      .describe(
        "Nome da disciplina para a qual a prova bot foi gerada. Opcional.",
      )
      .nullish(),
    date: z.optional(
      z
        .string()
        .datetime()
        .describe("Data de geração ou referência da prova bot."),
    ),
    classStudentCodes: z
      .array(z.string())
      .describe(
        "Lista de códigos dos grupos de alunos (ClassStudent) associados à prova bot.",
      )
      .nullish(),
    statusId: z.optional(
      z
        .number()
        .int()
        .describe(
          "Status atual da prova bot. Enum EClassroomBotExamStatus: `1` = PendingReview, `2` = PendingTranslation, `3` = Reviewed, `4` = Published.",
        ),
    ),
    statusText: z
      .string()
      .describe("Descrição textual do status da prova bot. Opcional.")
      .nullish(),
    canButtonPublish: z.optional(
      z
        .boolean()
        .describe(
          "Botão Publicar habilitado: status não é PendingReview nem Published.",
        ),
    ),
    canButtonTranslate: z.optional(
      z
        .boolean()
        .describe(
          "Botão Traduzir habilitado: status não é PendingReview nem Published.",
        ),
    ),
    canButtonReview: z.optional(
      z.boolean().describe("Botão Revisar habilitado: status != Published."),
    ),
    canButtonView: z.optional(
      z
        .boolean()
        .describe(
          "Botão Visualizar habilitado: apenas quando status == Published.",
        ),
    ),
  }) as unknown as ToZod<ClassroomDisciplineBotExamGridItemRepositoryResponse>;
